import { createContextStore } from "@faire/web--source/ui/hooks/ContextStore";
import getTime from "date-fns/getTime";
var _createContextStore = createContextStore({
    currentTime: getTime(new Date())
}, {
    name: "OpeningOrderIncentivesContextStore"
}), useStore = _createContextStore.useStore, Provider = _createContextStore.Provider;
export { useStore, Provider };
